import { api, useMutation } from "../../../../hooks"
import { useToaster } from "../../Toaster"

export const useSendEmail = () => {
  const toaster = useToaster()

  const { mutateAsync: sendEmail, isPending } = useMutation({
    mutationFn: () =>
      api("/api/users/security/step-up/reset-code", {
        method: "POST",
      }),
    onError: () => toaster.error("Une erreur est survenue"),
  })

  return {
    sendEmail,
    loading: isPending,
  }
}
